var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errorBox"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/images/404.png")}})]),_c('h3',[_vm._v("网页走失了~.~!")])])
}]

export { render, staticRenderFns }